import twoFA from './2FA/2FA-reducer'
import acquiring from './acquiring/acquiring-reducer'
import addresses from './addresses/addresses-reducer'
import alert from './alert/alert-reducer'
import allAssets from './allAssets/allAssets-reducer'
import batch from './batchPayments/batchPayments-reducer'
import cards from './cards/cards-reducer'
import common from './common/common-reducer'
import currencies from './currencies/currencies-reducer'
import dashboard from './dashboard/dashboard-reducer'
import digitalAssets from './digitalAssets/digitalAssets-reducer'
import favouritesDashboard from './favouritesDashboard/favouritesDashboard-reducer'
import googleAnalytics from './googleAnalytics/slice'
import ledger from './ledger/ledger-reducer'
import limitedTokens from './limitedTokens/limitedTokens-reducer'
import referrals from './referrals/referrals-reducer'
import settings from './settings/settings-reducer'
import toast from './toast/toast-reducer'
import tradingDeskV2 from './tradingDeskV2/tradingDeskV2-reducer'
import transactions from './transactions/transactions-reducer'
import user from './user/user-reducer'

const rootReducer = {
    user,
    ledger,
    transactions,
    toast,
    favouritesDashboard,
    alert,
    settings,
    twoFA,
    tradingDeskV2,
    common,
    digitalAssets,
    limitedTokens,
    dashboard,
    allAssets,
    cards,
    acquiring,
    addresses,
    currencies,
    referrals,
    batch,
    googleAnalytics,
}

export default rootReducer
